<template>
<div class="chapter">
<div class="inner_page">
<section class="level1" data-number="1" id="authors-note">
<h1 data-number="1">Author’s Note</h1>
<p>Benjamin Blackley is a fictional character. However, certain aspects of his story were inspired by the life of William Whiteley, the founder of Whiteleys department store, as described in Linda Stratmann’s fascinating account, <em>Whiteley’s Folly: The Life and Death of a Salesman</em> (Gloucestershire: The History Press, 2004).</p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch001.vue?aed840ec